import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/BlessedJourney.css';

const BlessedJourney = ({ isPreview = true }) => {
  const { childName } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse child name
  const formatName = (name) => {
    if (!name) return 'Baby';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const invitationData = {
    childName: formatName(childName),
    baptismDate: 'October 5, 2026',
    baptismDay: 'Sunday',
    baptismTime: '9:00 AM',
    church: 'Our Lady of Peace Church',
    churchAddress: 'Quezon City, Metro Manila',
    receptionVenue: 'Casa de Blessings',
    receptionAddress: '456 Faith Avenue, Quezon City',
    receptionTime: '11:30 AM',
    message: 'As we begin this blessed journey of faith, we invite you to share in the joy of our child\'s baptism.',
    verse: '"For this child I prayed, and the Lord has granted me what I asked of him." - 1 Samuel 1:27',
    godparents: ['Ninong Jose', 'Ninang Maria', 'Ninong Carlos', 'Ninang Teresa']
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="blessed-journey">
      {/* Sacred Elements */}
      <div className="sacred-elements">
        <div className="light-ray ray-1"></div>
        <div className="light-ray ray-2"></div>
        <div className="light-ray ray-3"></div>
        <div className="cross-bg cross-1">✝</div>
        <div className="cross-bg cross-2">✝</div>
        <div className="floating-element elem-1">☆</div>
        <div className="floating-element elem-2">☆</div>
        <div className="floating-element elem-3">☆</div>
      </div>

      {/* Main Content */}
      <div className={`blessed-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="blessed-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            ✝ Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            📖 Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            💌 RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="blessed-section home-section">
            <div className="blessed-frame">
              <div className="ornate-border">
                <div className="border-corner tl"></div>
                <div className="border-corner tr"></div>
                <div className="border-corner bl"></div>
                <div className="border-corner br"></div>
                
                <div className="home-content">
                  <div className="sacred-cross">
                    <span className="cross-icon">✝</span>
                    <span className="cross-glow"></span>
                  </div>
                  
                  <p className="blessing-text">In God's Grace</p>
                  
                  <div className="child-info">
                    <span className="child-name">{invitationData.childName}</span>
                    <span className="ceremony-label">will receive the Sacrament of</span>
                    <span className="ceremony-title">Holy Baptism</span>
                  </div>

                  <div className="blessed-divider">
                    <span className="divider-line"></span>
                    <span className="divider-icon">☧</span>
                    <span className="divider-line"></span>
                  </div>

                  <p className="invitation-message">{invitationData.message}</p>

                  <div className="scripture-verse">
                    <p>{invitationData.verse}</p>
                  </div>

                  <div className="event-snapshot">
                    <div className="snapshot-item">
                      <span className="snapshot-icon">📅</span>
                      <span>{invitationData.baptismDate}</span>
                    </div>
                    <div className="snapshot-item">
                      <span className="snapshot-icon">⛪</span>
                      <span>{invitationData.church}</span>
                    </div>
                  </div>

                  <button 
                    className="blessed-btn"
                    onClick={() => setActiveSection('details')}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="blessed-section details-section">
            <h2 className="section-title">
              <span className="title-cross">✝</span>
              Event Details
              <span className="title-cross">✝</span>
            </h2>

            <div className="details-cards">
              <div className="detail-card church-card">
                <div className="card-header">
                  <span className="card-icon">⛪</span>
                  <h3>Holy Mass & Baptism</h3>
                </div>
                <div className="card-body">
                  <p className="venue-name">{invitationData.church}</p>
                  <p className="venue-address">{invitationData.churchAddress}</p>
                  <p className="event-time">{invitationData.baptismTime}</p>
                </div>
              </div>

              <div className="detail-card reception-card">
                <div className="card-header">
                  <span className="card-icon">🍽️</span>
                  <h3>Reception</h3>
                </div>
                <div className="card-body">
                  <p className="venue-name">{invitationData.receptionVenue}</p>
                  <p className="venue-address">{invitationData.receptionAddress}</p>
                  <p className="event-time">{invitationData.receptionTime}</p>
                </div>
              </div>
            </div>

            <div className="godparents-section">
              <h3><span className="gp-icon">🙏</span> Ninong & Ninang</h3>
              <div className="godparents-grid">
                {invitationData.godparents.map((godparent, index) => (
                  <div key={index} className="godparent-item">
                    <span className="gp-badge">{godparent.startsWith('Ninong') ? '👔' : '👗'}</span>
                    <span className="gp-name">{godparent}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="attire-section">
              <h3>👗 Suggested Attire</h3>
              <div className="attire-info">
                <p className="attire-main">Sunday Best / Semi-Formal</p>
                <p className="attire-color">Color Motif: Ivory & Gold</p>
              </div>
            </div>

            <button 
              className="blessed-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              Kindly RSVP
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="blessed-section rsvp-section">
            <h2 className="section-title">
              <span className="title-cross">✝</span>
              RSVP
              <span className="title-cross">✝</span>
            </h2>

            <form className="blessed-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">Your presence will be a blessing</p>
              <p className="rsvp-deadline">Please respond by September 25, 2026</p>

              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your full name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be joining us?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✓</span>
                    <span className="option-text">Blessed to Attend</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">✗</span>
                    <span className="option-text">Unable to Attend</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                  <option value="5">5+ Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Prayer & Wishes (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your prayers and blessings..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="blessed-btn submit-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="blessed-watermark">
          <a href="/invitations" className="back-to-templates-btn">← Back to Templates</a>
          <p>Created with 🙏 by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default BlessedJourney;
